import React from "react";

export default function PatientsFirst() {
  const styles = {
    section: {
      background: "transparent",
      padding: "clamp(20px, 3vw, 36px) clamp(16px, 2vw, 28px)",
    },
    /* Match your Mission width so it lines up left/right */
    container: {
      maxWidth: "min(1600px, 94vw)",
      margin: "0 auto",
    },
    card: {
      background: "#ffffff",
      borderRadius: 18,
      boxShadow: "0 10px 40px rgba(13, 43, 69, 0.08)",
      padding: "clamp(18px, 3vw, 28px)",
      border: "1px solid rgba(13, 43, 69, 0.06)",
    },
    overline: {
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      flexWrap: "wrap",
      fontFamily: "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      fontWeight: 800,
      fontSize: "clamp(14px, 1.2vw, 16px)",
      color: "var(--text-heading)",
      marginBottom: 8,
    },
    badge: {
      display: "inline-block",
      fontFamily: "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      fontWeight: 700,
      fontSize: "clamp(12px, 1vw, 14px)",
      color: "var(--text-heading)",
      background: "var(--color-pink-200)",
      border: "1px solid rgba(13,43,69,0.12)",
      padding: "6px 10px",
      borderRadius: 999,
    },
    h2: {
      fontFamily: "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      fontWeight: 800,
      fontSize: "clamp(22px, 2.2vw, 30px)",
      lineHeight: 1.25,
      margin: "6px 0 10px 0",
      color: "var(--text-heading)",
    },
    p: {
      fontFamily: "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      fontSize: "clamp(16px, 1.15vw, 18px)",
      lineHeight: 1.65,
      color: "var(--text-primary)",
      margin: "10px 0",
    },
    learn: {
      display: "inline-block",
      marginTop: 10,
      fontFamily: "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      fontWeight: 800,
      fontSize: "clamp(14px, 1.1vw, 16px)",
      color: "var(--accent)",
      textDecoration: "none",
    },
    goalsWrap: {
      display: "grid",
      gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
      gap: 14,
      marginTop: 16,
    },
    goalItem: {
      background: "rgba(205, 230, 255, 0.4)",
      border: "1px solid rgba(13,43,69,0.08)",
      borderRadius: 12,
      padding: "12px 14px",
      fontFamily: "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      color: "var(--text-heading)",
      fontSize: "clamp(15px, 1.05vw, 17px)",
      lineHeight: 1.45,
      fontWeight: 700,
    },
    arrow: {
      fontWeight: 800,
      margin: "0 6px",
      color: "var(--accent)",
    },
  };

  return (
    <section id="PatientsFirst" style={styles.section} aria-label="Patients First">
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.overline}>
            <span>Project — Patients First</span>
            <span style={styles.badge}>
              2025 United Nations Youth ChangeMaker • Selected from 2000+ applications
            </span>
          </div>

          <h2 style={styles.h2}>Patients First</h2>

          <p style={styles.p}>
            PatientFirst is a community- and corporate-funded pilot ensuring no cancer patient
            misses treatment because of barriers beyond medicine. Launched with 50+ patients at
            Penn Medicine Princeton Medical Center and supported by 10+ passionate volunteers, it
            tackles transportation and home-support needs head-on. Our goal is simple: zero missed
            appointments, stronger families, and healthier hospitals — creating a model that can
            scale across Penn Medicine and beyond.{" "}
            <a href="#Contact" style={styles.learn}>Learn more →</a>
          </p>

          <p style={styles.p}>
            PatientFirst exists to ensure no cancer patient misses treatment because of barriers
            beyond medicine. By tackling transportation and home-support needs, we improve survival
            outcomes, ease caregiver burdens, and strengthen hospitals. Our pilot, launched with
            50+ patients at Penn Medicine Princeton Medical Center, is community- and
            corporate-funded and supported by 10+ passionate volunteers. PatientFirst is proving
            what’s possible: eliminating missed appointments, easing daily burdens, and creating a
            scalable model that can expand across the entire Penn Medicine system to reach
            underserved patients everywhere.
          </p>

          <h3 style={{...styles.h2, fontSize: "clamp(18px, 1.6vw, 22px)", marginTop: 18}}>
            Our Goals
          </h3>

          <div style={styles.goalsWrap}>
            <div style={styles.goalItem}>
              Zero missed appointments <span style={styles.arrow}>→</span> better survival outcomes
            </div>
            <div style={styles.goalItem}>
              Relief from home-support burdens <span style={styles.arrow}>→</span> stronger patients and families
            </div>
            <div style={styles.goalItem}>
              Improved hospital efficiency <span style={styles.arrow}>→</span> healthier communities
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
